export const TEMP_TOKEN = "TEMP_TOKEN";

export const setTempToken = (data) => {
  return {
    type: TEMP_TOKEN,
    data,
  };
};
